import React, { Fragment } from "react";

export interface ILocationNameProps {
    locationId?: string;
}

export const LocationName: React.FC<ILocationNameProps> = ({ locationId }) => {


    return (
        <Fragment>
            Unconfigure LocationName: {locationId}
        </Fragment>
    )
};